import { Route } from '../types';

import { AboutUs } from './AboutUs';
import { Cashback } from './Cashback';
import { Conversation } from './Conversation';
import { CookiePolicy } from './CookiePolicy';
import { DesignSystem } from './DesignSystem';
import { EmailUnsubscribe } from './EmailUnsubscribe';
import { Home } from './Home';
import { HowDoesItWorkLandlord } from './HowDoesItWorkLandlord';
import { HowDoesItWorkTenant } from './HowDoesItWorkTenant';
import { LandlordPremium } from './LandlordPremium';
import { LandlordPublicProfile } from './LandlordPublicProfile';
import { LCFAddress } from './LCFAddress';
import { LCFAvailability } from './LCFAvailability';
import { LCFContinue } from './LCFContinue';
import { LCFCurrentResidents } from './LCFCurrentResidents';
import { LCFDetails } from './LCFDetails';
import { LCFListingType } from './LCFListingType';
import { LCFMedia } from './LCFMedia';
import { LCFOwnerType } from './LCFOwnerType';
import { LCFPreferredTenant } from './LCFPreferredTenant';
import { LCFReactivate } from './LCFReactivate';
import { LCFRentalPrice } from './LCFRentalPrice';
import { LCFStart } from './LCFStart';
import { LCFStudentHouse } from './LCFStudentHouse';
import { LCFSupplyProducts } from './LCFSupplyProducts';
import { LCFSurfaceFurnishing } from './LCFSurfaceFurnishing';
import { LCFTitleDescription } from './LCFTitleDescription';
import { LegacyLogin } from './LegacyLogin';
import { ListingDetails } from './ListingDetails';
import { ListingDetailsPreview } from './ListingDetailsPreview';
import { ListingsSearchCity, ListingsSearchStreet } from './ListingsSearch';
import { ListingsSearchSitemapByCityID } from './ListingsSearchSitemapByCityID';
import { ListingsSearchSitemapBySearchCategory } from './ListingsSearchSitemapBySearchCategory';
import { MakePayment } from './MakePayment';
import { MyAccount } from './MyAccount';
import { MyAlerts } from './MyAlerts';
import { MyConversations } from './MyConversations';
import { MyDashboard } from './MyDashboard';
import { MyFavoriteListings } from './MyFavoriteListings';
import { MyFavoriteTenants } from './MyFavoriteTenants';
import { MyListings } from './MyListings';
import { MyPublicProfile } from './MyPublicProfile';
import { MySettings } from './MySettings';
import { NotFound } from './NotFound';
import { Partnerships } from './Partnerships';
import { PaymentReminder } from './PaymentReminder';
import { PaymentStatus } from './PaymentStatus';
import { PremiumListing } from './PremiumListing';
import { PrivacyPolicy } from './PrivacyPolicy';
import { ReactToListing } from './ReactToListing';
import { ReactToListingSuccess } from './ReactToListingSuccess';
import { ReferFriend } from './ReferFriend';
import { RentOutHome } from './RentOutHome';
import { RentOutRoom } from './RentOutRoom';
import { SafetyLandlord } from './SafetyLandlord';
import { SafetyTenant } from './SafetyTenant';
import { Signin } from './Signin';
import { Signout } from './Signout';
import { Signup } from './Signup';
import { StaticSitemap } from './StaticSitemap';
import { StudentHouse } from './StudentHouse';
import { StylesDesign } from './StylesDesign';
import { StylesMUI } from './StylesMUI';
import { TenantPublicProfile } from './TenantPublicProfile';
import { TenantsSearch } from './TenantsSearch';
import { TermsAndConditions } from './TermsAndConditions';
import { UnsubscribeEmail } from './UnsubscribeEmail';

export const ROUTES = Object.freeze({
  Home,
  Signin,
  Signup,
  Signout,
  LegacyLogin,
  TenantsSearch,
  MyDashboard,
  MyConversations,
  ReactToListing,
  ReactToListingSuccess,
  Conversation,
  MyAccount,
  MyPublicProfile,
  MyAlerts,
  MySettings,
  ReferFriend,
  Cashback,
  MyFavoriteListings,
  MyFavoriteTenants,
  LCFStart,
  LCFContinue,
  LCFListingType,
  LCFOwnerType,
  LCFStudentHouse,
  LCFAddress,
  LCFAvailability,
  LCFSurfaceFurnishing,
  LCFRentalPrice,
  LCFMedia,
  LCFDetails,
  LCFPreferredTenant,
  LCFCurrentResidents,
  LCFTitleDescription,
  LCFSupplyProducts,
  LCFReactivate,
  MyListings,
  RentOutRoom,
  RentOutHome,
  StudentHouse,
  SafetyLandlord,
  SafetyTenant,
  HowDoesItWorkTenant,
  HowDoesItWorkLandlord,
  TermsAndConditions,
  PrivacyPolicy,
  CookiePolicy,
  PremiumListing,
  MakePayment,
  PaymentReminder,
  AboutUs,
  PaymentStatus,
  Partnerships,
  LandlordPremium,
  UnsubscribeEmail,
  ListingsSearchCity,
  ListingsSearchStreet,
  ListingDetails,
  ListingDetailsPreview,
  LandlordPublicProfile,
  EmailUnsubscribe,
  ListingsSearchSitemapBySearchCategory,
  ListingsSearchSitemapByCityID,
  TenantPublicProfile,
  NotFound,
  DesignSystem,
  StylesDesign,
  StylesMUI,
  StaticSitemap,
});

export function getRouteByPathname(pathname: string) {
  return Object.values(ROUTES).find(
    route => route.pathname === pathname,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) as Route<any> | undefined;
}
